import { TFunction } from 'i18next'
import './SubmissionInfo.scss'

export const SubmissionInfo: React.FC<{
  formState: any
  applicationId: string
  ovrMailinBallotApplicationId?: string
  applicationDate: string
  t: TFunction
}> = ({
  formState,
  applicationId,
  applicationDate,
  t,
  ovrMailinBallotApplicationId,
}) => {
  return (
    <div className="submission-info">
      <div className="submission-info__label">
        {t('submissionInfoLabels.applicationId')}
      </div>
      <div className="submission-info__value">{applicationId}</div>
      {ovrMailinBallotApplicationId ? (
        <>
          <div className="submission-info__label">
            {t('submissionInfoLabels.ovrMailinBallotApplicationId')}
          </div>
          <div className="submission-info__value">
            {ovrMailinBallotApplicationId}
          </div>
        </>
      ) : null}
      <div className="submission-info__label">
        {t('submissionInfoLabels.voterName')}
      </div>
      <div className="submission-info__value">{`${formState.firstName} ${formState.lastName}`}</div>
      <div className="submission-info__label">
        {t('submissionInfoLabels.county')}
      </div>
      <div className="submission-info__value">{formState.county}</div>

      <div className="submission-info__label">
        {t('submissionInfoLabels.applicationDate')}
      </div>
      <div className="submission-info__value">{applicationDate}</div>
    </div>
  )
}
